import { ContentWrap } from '@txt/taxonomy.ui.common/styles/elements';
import * as React from 'react';

/** Layout wrapper for all public available pages. */
export const PublicPageLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <ContentWrap>{children}</ContentWrap>;
};
